<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="date"
    :rules="rules"
    :error-messages="errorMessages"
    :required="required"
    :value="value"
    :disabled="disabled"
    transition="scale-transition"
    offset-y
    min-width="290px">
    <template v-slot:activator="{ on }">
      <v-text-field v-model="dateFormatted"
                    :label="label"
                    :style="disabled ? 'opacity: 0.2 !important' : ''"
                    v-on="on"
                    prepend-icon="event"
                    readonly />
    </template>
    <v-date-picker v-model="date"
                   :type="pickerType"
                   :max="today"
                   :range="range"
                   :first-day-of-week="1"
                   :class="disabled ? 'input-disabled':''"
                   :disabled="disabled"
                   no-title
                   locale="ru-ru"

                   scrollable>
      <v-spacer />

      <!--<v-btn text color="primary" @click="menu = false">Cancel</v-btn>-->
      <!--<v-btn text color="primary" @click="save(date)">OK</v-btn>-->
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  name: "BaseDatePicker",
  props: {
    label: {
      type: String,
      default: 'Выберите дату'
    },
    rules: {
      type: Array,
      default: () => []
    },
    errorMessages: {
      type: String,
      default: ''
    },
    pickerType: {
      type: String,
      default: 'date'
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Array, Object, Number, String],
      default: () => []
    },
    //  dateProp: {
    //   type: String,
    //    required: true
    //   // default: () => new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10)
    //   // default: () =>  new Date().toISOString().substr(0, 10)
    // },
    disabled: {
      type: Boolean,
      default: false
    },
    range: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      menu: false,
      date: this.value ? this.value : new Date().toISOString().substr(0, 10),
      dateFormatted: this.formatDate(this.value),
      today:  this.pickerType ==='date' ? new Date().toISOString().substr(0, 10) :  new Date().toISOString().substr(0, 7)
    }
  },
  watch: {
    value (newValue) {
      this.date = newValue
    },
    date (newValue) {
      this.dateFormatted = this.formatDate(newValue)
      this.$refs.menu.save(newValue)
      this.$emit('dateUpdated', newValue)
    }
  },
  methods: {
    save (date) {
      this.$refs.menu.save(date)
      this.$emit('dateUpdated', date)
    },
    formatDate (date) {
      const [year, month, day] = date.split('-')
      if (this.pickerType==='month')
        return `${month}.${year}`
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) return null
      if (this.pickerType==='month') {
          const [month, year] = date.split('.')
          // //console.log('km', `${year}-${month.padStart(2, '0')}-01`)
          return `${year}-${month.padStart(2, '0')}-01`
        }
      const [day, month, year] = date.split('.')
      let parsed = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      // //console.log(parsed)
      // this.$emit('dateUpdated', parsed)
      return parsed
    }
  }
}
</script>

<style scoped lang="scss">
 /deep/ .input-disabled {
   opacity: 0.3 !important;
 }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseDatePicker.vue